import React from "react";
import Card from "components/card";
import { Target } from "lucide-react";
import AccessButton from "components/button/accessbutton";
import { tasks } from "./Tasks"

const MyGoals = () => {
    return (
        <Card className="text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 bg-white dark-mode-card">
            <div className="grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 [.border-b]:pb-6 pb-3">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="p-2 rounded-full bg-gradient-to-br from-blue-500 to-cyan-500">
                            <Target className="w-5 h-5 text-white" />
                        </div>
                        <div>
                            <h4 className="text-[16px] title-text">
                                My Goals
                            </h4>
                            <p className="muted-text text-[11px]">
                                Q4 2025 objectives
                            </p>
                        </div>
                    </div>
                    <AccessButton
                        label="View All"
                        to="/console/performance-goals"
                        btnClass="btn-view-all"
                    />
                </div>
            </div>
            <div className="px-6 pb-6 pt-2"> 
                <div className="space-y-3">
                    {tasks.map((item, index) => (
                        <div 
                            key={index} 
                            className="space-y-1.5"
                        >
                            <div className="flex items-start justify-between gap-2">
                                <p className="text-[12px] font-medium title-text">
                                    {item.task}
                                </p>
                                <span className="text-[11px] font-semibold text-emerald-600 dark:text-emerald-500">
                                    {item.progress}%
                                </span>
                            </div>
                            <div className="w-full bg-slate-200 rounded-full h-1.5">
                                <div 
                                    className="bg-gradient-to-r from-emerald-500 to-green-500 h-1.5 rounded-full transition-all"
                                    style={{ width: `${item.progress}%` }}
                                >    
                                </div>
                            </div>
                            <p className="text-[10px] muted-text">
                                Due: {item.due}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </Card>
    )
};
export default MyGoals;